module.exports = __webpack_public_path__ + "static/media/intro.8cc62e9d.mp3";